/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Bell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Bell"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M15.3 18.667C15.3 20.507 13.822 22 12 22s-3.3-1.492-3.3-3.333H5.117c-1.29 0-2.058-1.452-1.343-2.535A9.86 9.86 0 0 0 5.4 10.704V9.46c0-3.2 2.568-5.792 5.734-5.792h.041v-.834c0-.46.37-.833.825-.833a.83.83 0 0 1 .825.833v.834h.041c3.166 0 5.734 2.593 5.734 5.792v1.245c0 1.932.566 3.82 1.626 5.428.715 1.083-.053 2.535-1.343 2.535zm-4.95 0c0 .92.739 1.666 1.65 1.666s1.65-.746 1.65-1.666zm.784-13.334C8.879 5.333 7.05 7.18 7.05 9.46v1.245c0 2.239-.649 4.427-1.866 6.296h13.633a11.53 11.53 0 0 1-1.867-6.296V9.46c0-2.279-1.829-4.126-4.084-4.126z"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const BellIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'bell-icon'}
      icon={Bell}
      {...props}
      size={size}
    />
  );
};
